<template>
    <div class="tsa-environmentCheck" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <img src="./images/wuhen.png" alt="">
            <p>{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            show: false,
            message: ''
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-environmentCheck {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        .mask {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(0,0,0,0.5);
            z-index: 1;
        }
        .content {
            position: absolute;
            z-index: 2;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 220px;
            height: 184px;
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 1px rgba(7,12,20,0.12);
            border-radius: 6px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            img  {
                width: 40px;
                height: auto;
                margin-top: 50px;
                margin-bottom: 19px;
            }
            p {
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                line-height: 22px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/environmentCheck/index.vue